// NOTE: Embedded Tweets  -> https://developer.twitter.com/en/docs/twitter-for-websites/embedded-tweets/guides/embedded-tweet-parameter-reference
//       https://github.com/saurabhnemade/react-twitter-embed#readme

import React from "react";
import { PostContainer, Content } from "./Shared";
import styled from "styled-components";
import PostFooter from "../PostFooter/PostFooter";
import { TwitterTweetEmbed } from "react-twitter-embed";
import Spinner from "components/Spinner";

const TweetWrapper = styled.div`
  min-height: 200px;
  position: relative;
  z-index: 1;
`;

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  opacity: 0.2;
`;

export default function PhotoPost(props) {
  const renderPostFooter = () =>
    props.activeAudience || props.showPostFooter ? (
      <PostFooter {...props} />
    ) : null;
  return (
    <PostContainer {...props}>
      <Content>
        <SpinnerWrapper>
          <Spinner hideBackground />
        </SpinnerWrapper>
        <TweetWrapper>
          <TwitterTweetEmbed
            tweetId={props.content}
            options={{
              align: "center",
              width: "550",
            }}
            className="tweetEmbed"
          />
        </TweetWrapper>
      </Content>
      {renderPostFooter()}
    </PostContainer>
  );
}
